import classNames from 'classnames';
import styles from './BottomViewHeaders.module.css';

const BottomViewHeaders = (props) => {
    return (
        <div className={classNames(styles.container, props.className)}>
            {
                props.numOfComments > 0 && (
                    <span className={classNames(styles.header, {[styles.selected]: props.selectedView === 'comments'})} onClick={() => props.setView('comments')}>
                        Comments ({props.numOfComments})
                    </span>
                )
            }
            {
                (props.numOfUpdates > 0 || props.isOwnFundraiser) && (
                    <span className={classNames(styles.header, {[styles.selected]: props.selectedView === 'updates'})} onClick={() => props.setView('updates')}>
                        Updates ({props.numOfUpdates})
                    </span>
                )
            }
            {
                props.numOfChanges > 0 && (
                    <span className={classNames(styles.header, {[styles.selected]: props.selectedView === 'changes'})} onClick={() => props.setView('changes')}>
                        Change History ({props.numOfChanges})
                    </span>
                )
            }
        </div>
    )
};

export default BottomViewHeaders;